/**
 * The documents of an asset's series (`Asset.productSeries`, docs/product-series-entwurf.md) as read-only rows of the
 * documents tab. A maintenance document of a CONFIRMED series counts as the manufacturer's instructions (decision 1);
 * everything else at the series is information beside the product's documents.
 */
import type { ExtraDocument } from "../components/EntityDocumentsPanel";

const KNOWN_ROLES = ["manual", "datasheet", "certificate", "drawing", "maintenance"];

/** The ManagedFile ids a series lists — stored as ids or as `{ documentId }` links. */
export const seriesDocumentIds = (series: any): string[] =>
  (Array.isArray(series?.documents) ? series.documents : [])
    .map((d: any) => String(d?.documentId ?? d?._id ?? d ?? ""))
    .filter((id: string) => /^[a-f0-9]{24}$/i.test(id));

export const seriesDocumentEntries = (
  series: any,
  files: any[],
  t: (key: string) => string,
): ExtraDocument[] => {
  const confirmed = series?.status === "confirmed";
  return files.filter(Boolean).map((mf: any) => {
    const segs = String(mf.path || "").split("/").filter(Boolean);
    let name = segs[segs.length - 1] || "document";
    try {
      name = decodeURIComponent(name);
    } catch {
      /* keep the raw name */
    }
    const roles: string[] = Array.isArray(mf.roles) ? mf.roles : [];
    const role = KNOWN_ROLES.includes(roles[0]) ? roles[0] : "other";
    return {
      type: t(`assetPropertiesPanel.documents.role.${role}`),
      synopsis: name,
      url: `/managed-files/${mf._id}`,
      origin: "series" as const,
      fulfilsManufacturerReference: confirmed && roles.includes("maintenance"),
    };
  });
};
